/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {DischargeRolesRequest} from '../models/DischargeRolesRequest';
import type {DischargeRolesResponse} from '../models/DischargeRolesResponse';
import type {Error} from '../models/Error';

export interface BulkDischargeRolesProgress$Request {
    id: string;
}

export interface BulkDischargeRolesProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkDischargeRolesProgressRequest = createAction<PayloadData<void, BulkDischargeRolesProgress$Request>>('BULK_DISCHARGE_PRESET_ROLES__BULK_DISCHARGE_ROLES_PROGRESS__REQUEST');
export const bulkDischargeRolesProgressSuccess = createAction<PayloadData<BulkProgress, BulkDischargeRolesProgress$Request>>('BULK_DISCHARGE_PRESET_ROLES__BULK_DISCHARGE_ROLES_PROGRESS__SUCCESS');
export const bulkDischargeRolesProgressFailure = createAction<PayloadData<Error, BulkDischargeRolesProgress$Request, true>>('BULK_DISCHARGE_PRESET_ROLES__BULK_DISCHARGE_ROLES_PROGRESS__FAILURE');

export const bulkDischargeRolesProgressActions = [
    bulkDischargeRolesProgressRequest,
    bulkDischargeRolesProgressSuccess,
    bulkDischargeRolesProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkDischargeRolesProgress = (meta: BulkDischargeRolesProgress$Request, config?: BulkDischargeRolesProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: bulkDischargeRolesProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/presets/discharge-roles/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface DischargeRoles$Request {
    dischargeRolesRequest: DischargeRolesRequest;
}

export interface DischargeRoles$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const dischargeRolesRequest = createAction<PayloadData<void, DischargeRoles$Request>>('BULK_DISCHARGE_PRESET_ROLES__DISCHARGE_ROLES__REQUEST');
export const dischargeRolesSuccess = createAction<PayloadData<string, DischargeRoles$Request>>('BULK_DISCHARGE_PRESET_ROLES__DISCHARGE_ROLES__SUCCESS');
export const dischargeRolesFailure = createAction<PayloadData<Error, DischargeRoles$Request, true>>('BULK_DISCHARGE_PRESET_ROLES__DISCHARGE_ROLES__FAILURE');

export const dischargeRolesActions = [
    dischargeRolesRequest,
    dischargeRolesSuccess,
    dischargeRolesFailure
] as const;

/**
 * @param {DischargeRolesRequest} meta.dischargeRolesRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const dischargeRoles = (meta: DischargeRoles$Request, config?: DischargeRoles$Config) => {
    return {
        CALL_API: {
            types: dischargeRolesActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/presets/discharge-roles`,
            TRANSPORT_REQUEST_BODY: meta.dischargeRolesRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDischargeRolesResult$Request {
    id: string;
}

export interface GetDischargeRolesResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDischargeRolesResultRequest = createAction<PayloadData<void, GetDischargeRolesResult$Request>>('BULK_DISCHARGE_PRESET_ROLES__GET_DISCHARGE_ROLES_RESULT__REQUEST');
export const getDischargeRolesResultSuccess = createAction<PayloadData<DischargeRolesResponse, GetDischargeRolesResult$Request>>('BULK_DISCHARGE_PRESET_ROLES__GET_DISCHARGE_ROLES_RESULT__SUCCESS');
export const getDischargeRolesResultFailure = createAction<PayloadData<Error, GetDischargeRolesResult$Request, true>>('BULK_DISCHARGE_PRESET_ROLES__GET_DISCHARGE_ROLES_RESULT__FAILURE');

export const getDischargeRolesResultActions = [
    getDischargeRolesResultRequest,
    getDischargeRolesResultSuccess,
    getDischargeRolesResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDischargeRolesResult = (meta: GetDischargeRolesResult$Request, config?: GetDischargeRolesResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getDischargeRolesResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/presets/discharge-roles`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

